import React from "react";
import { connect } from "react-redux";
import { setClickedTimeBlock } from "../redux/actions";
import {
    selectDayRange,
    selectClickedDayTimeBlock,
    selectWeekCount
} from "../redux/selectors";
import moment from "moment";

class DayView extends React.Component {
    render() {
        if (!this.props.weekCount) {
            return null;
        }
        return (
            // <div className="TrackContainer DayTrackContainer">

            <div
                className="Track DayTrack"
                style={{
                    gridTemplateColumns: `repeat(${this.props.weekCount *
                        7}, auto)`,
                    marginRight: `${this.props.weekCount * 6.5 + 1}px`,
                    overflow: "none"
                }}
            >
                {new Array(this.props.weekCount * 7).fill(true).map((e, i) => {
                    const newStartDate = moment(this.props.dayRange.start).add(
                        i,
                        "days"
                    );
                    const date = moment(newStartDate, "ddd Do MMM")
                        .toString()
                        .split(" ");
                    let selected =
                        this.props.clickedDayTimeBlock ===
                        moment(newStartDate, "ddd Do MMM")
                            ? "-selected"
                            : "";

                    const day = date[0];
                    const month = date[2];
                    const dateNumber = date[1];
                    return (
                        <React.Fragment key={i}>
                            <div
                                className={"TimeblockControl"}
                                style={{
                                    gridColumnStart: i + 1,
                                    gridColumnEnd: i + 1
                                }}
                            />

                            <div
                                className={`Dayblock${selected}`}
                                style={{
                                    gridColumnStart: i + 1,
                                    gridColumnEnd: i + 1
                                }}
                                onClick={() => {
                                    const clickedDate = newStartDate.format(
                                        "ddd Do MMM"
                                    );

                                    this.props.setClickedTimeBlock(clickedDate);
                                }}
                            >
                                <div className={"Dayblock-date"}>
                                    {dateNumber} {month}
                                </div>
                                <div className={"Dayblock-day"}>{day}</div>
                            </div>
                        </React.Fragment>
                    );
                })}
            </div>
        );
    }
}

export default connect(
    store => {
        return {
            dayRange: selectDayRange(store),
            clickedDayTimeBlock: selectClickedDayTimeBlock(store),
            weekCount: selectWeekCount(store)
        };
    },
    { setClickedTimeBlock }
)(DayView);
